import { RootState } from '../store';

export const selectApp = (state: RootState) => state.app;
export const selectLoadingState = (state: RootState) => state.app.loadingState;
export const selectLocale = (state: RootState) => state.app.locale;
